import { render, staticRenderFns } from "./stock-trade.vue?vue&type=template&id=5675d5b3&"
import script from "./stock-trade.vue?vue&type=script&lang=js&"
export * from "./stock-trade.vue?vue&type=script&lang=js&"
import style0 from "./stock-trade.vue?vue&type=style&index=0&id=5675d5b3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports